const POSTIT_SIZE = 360
const WORLD_PADDING = 600

export function computeWorldSize(items) {
    if (!items.length) {
        return { width: 2000, height: 2000, offsetX: 0, offsetY: 0 }
    }

    let minX = Infinity
    let maxX = -Infinity
    let minY = Infinity
    let maxY = -Infinity

    for (const item of items) {
        const x = item.x
        const y = item.y
        if (x < minX) minX = x
        if (x > maxX) maxX = x
        if (y < minY) minY = y
        if (y > maxY) maxY = y
    }

    const width = (maxX - minX) + POSTIT_SIZE + WORLD_PADDING * 2
    const height = (maxY - minY) + POSTIT_SIZE + WORLD_PADDING * 2

    return {
        width: Math.max(width, 2000),
        height: Math.max(height, 2000),
        offsetX: -minX + WORLD_PADDING + POSTIT_SIZE / 2,
        offsetY: -minY + WORLD_PADDING + POSTIT_SIZE / 2,
    }
}
